/*
 * @Author: DY
 * @Date: 2022-06-28 11:47:47
 * @LastEditTime: 2026-10-27 15:25:47
 * @Description: 全局挂载方法
 * @Param:
 * @FilePath: \ProjectTree_vue2\ConcreteCloud_Web\src\assets\js\currencyFun\globalMountFun.js
 */
import store from '@/store';
import axios from 'axios';
import util from '@/utils/util';

// excel导出
function leadingOut(res, type) {
    const file = res.data ? res.data : res;
    const blob = new Blob([file], { type: type });
    let fileName = '';
    if (res.headers) {
        fileName = decodeURIComponent(res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1]);
    } else {
        fileName = `导出数据-${util.timeFormat(new Date(new Date()), 'yyyy-MM-dd')}.xls`;
    }
    if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
    } else { // IE10+下载
        navigator.msSaveBlob(blob, fileName);
    }
}


export default {
    install(Vue) {
        /**
         * 获取登录用户信息
         * fieldName        返回字段名称
         */
        Vue.prototype.$takeTokenParameters = function (fieldName) {
            const info = sessionStorage.getItem('userInfo');
            const userInfo = JSON.parse(decodeURI(info));
            let callbackData = null;
            if (fieldName) {
                if (userInfo[fieldName]) {
                    callbackData = userInfo[fieldName];
                } else {
                    // this.$message({
                    //     showClose: true,
                    //     message: `没有查询到用户【${fieldName}】数据！`,
                    //     type: 'error',
                    // });
                    console.log(`没有查询到用户【${fieldName}】数据！`);
                }
            } else {
                callbackData = userInfo;
            }
            return callbackData;
        };
        /**
         * 获取地址栏参数
         * requestUrl       地址
         * item             参数名称
         */
        Vue.prototype.$queryString = function (requestUrl, item) {
            let callbackData = null;
            if (requestUrl && requestUrl.length > 0) {
                const querys = requestUrl.split('&');
                const result = {};
                for (let i = 0; i < querys.length; i++) {
                    const temp = querys[i].split('=');
                    if (temp.length < 2) {
                        result[temp[0]] = '';
                    } else {
                        result[temp[0]] = temp[1];
                    }
                }
                if (item) {
                    callbackData = result[item];
                } else {
                    callbackData = result;
                }
            }
            return callbackData;
        };

        /**
         * 接口导出excel
         * requestUrl       地址
         * parameter        参数
         * exportMethod     导出方式（默认get）
         * postExport       post导出参数
         */
        Vue.prototype.$exportExcel = function ({
            requestUrl,
            parameter = {
                responseType: 'arraybuffer',
                type: 'application/octet-stream',
            },
            exportMethod = 'get',
            postExport = {},
        }) {
            if (exportMethod === 'get') {
                axios.get(
                    requestUrl,
                    { responseType: parameter.responseType }
                ).then(res => {
                    leadingOut(res, parameter.type);
                    localStorage.removeItem('export_loading');
                }).catch(e => {
                    Vue.$message.error(e.ErrorCode.Message);
                    localStorage.removeItem('export_loading');
                });
            } else {
                axios.post(
                    requestUrl,
                    postExport,
                    { responseType: parameter.responseType }
                ).then(res => {
                    leadingOut(res, parameter.type);
                    localStorage.removeItem('export_loading');
                }).catch(error => {
                    Vue.$message.error(error.ErrorCode.Message);
                    localStorage.removeItem('export_loading');
                });
            }
        };

        Vue.prototype.$YWShowLayer = function (formParam, keyValue, btn, type) {
            const YWShowLayer = this.$toast({
                width: '80%',
                type: 'eject',
                title: true,
                t_url: 'popUpForm/index',
                extr: {
                    closeBtn: 'width: 80px; height: 80px;',
                    code: {
                        FormUrl: formParam,
                        FormKeyValue: keyValue,
                        ThreeBtnDescribe: btn,
                        FormUseInJyFlow: false,
                        type,
                    },
                },
                viewPosition: 'components',
            });
            return YWShowLayer;
        };

        /*
         * 流程表单查看[弹出多表单+附件]
         * contract_number: 合同编号
         * viewScene: 视图场景【打开方式】
        */
        Vue.prototype.$processFormView = function (contract_number, viewScene) {
            const processFormView = this.$toast({
                width: '80%',
                type: 'eject',
                title: true,
                text: '合同查看',
                t_url: 'popUpForm/index_see',
                extr: {
                    code: {
                        contractNumber: contract_number,
                        viewScene: viewScene,
                    },
                },
                viewPosition: 'components',
            });
            return processFormView;
        };

        /*
         * 流程表单查看[弹出多表单+附件]
         * 合同台账合并后的，新增，维护弹窗
         * contract_number: 合同编号
         * viewScene: 视图场景【打开方式】
        */
        Vue.prototype.$processStageFormView = function (contract_number, viewScene, cvid) {
            const processStageFormView = this.$toast({
                width: '80%',
                type: 'eject',
                title: true,
                text: '合同查看',
                t_url: 'popUpForm/index_stb',
                extr: {
                    code: {
                        contractNumber: contract_number ? contract_number : '',
                        cvid: cvid ? cvid : null,
                        viewScene: viewScene,
                    },
                },
                viewPosition: 'components',
            });
            return processStageFormView;
        };

        Vue.prototype.$HsAndHdLayer = function (formParam, keyValue, btnDescribe, btnStatus) {
            const HsAndHdLayer = this.$toast({
                width: '80%',
                type: 'eject',
                title: true,
                t_url: 'accountingManagement/popUpForm/index',
                extr: {
                    closeBtn: 'width: 80px; height: 80px;',
                    code: {
                        FormUrl: formParam,
                        FormKeyValue: keyValue,
                        ThreeBtnDescribe: btnDescribe,
                        BtnStatus: btnStatus,
                        FormUseInJyFlow: false,
                    },
                },
                viewPosition: 'views',
            });
            return HsAndHdLayer;
        };
        Vue.prototype.$ShowManyButtonForm = function (formParam, keyValue, btnList) {
            const ShowManyButtonForm = this.$toast({
                width: '80%',
                type: 'eject',
                title: true,
                t_url: 'accountingManagement/popUpForm/formIndex',
                extr: {
                    closeBtn: 'width: 80px; height: 80px;',
                    code: {
                        FormUrl: formParam,
                        FormKeyValue: keyValue,
                        btnList: btnList,
                        FormUseInJyFlow: false,
                    },
                },
                viewPosition: 'views',
            });
            return ShowManyButtonForm;
        };

        /*
         * 全局自定义按钮弹出表单
         * formParam: 表单code
         * keyValue: 表单编号
         * saveCallback: 保存成功调用
         * btnList: 自定义按钮组
        */
        Vue.prototype.$customButtonForm = function (formParam, keyValue, saveCallback, btnList) {
            const customButtonForm = this.$toast({
                width: '80%',
                type: 'eject',
                title: true,
                t_url: 'accountingManagement/popUpForm/customBtnForm',
                extr: {
                    closeBtn: 'width: 80px; height: 80px;',
                    code: {
                        FormUrl: formParam,
                        FormKeyValue: keyValue,
                        saveCallback: saveCallback,
                        btnList: btnList,
                    },
                },
                viewPosition: 'views',
            });
            return customButtonForm;
        };

        // 业务通用弹出层
        Vue.prototype.$YWShowMultipleForms = function (forms, width = '80%') {
            const YWShowMultipleForms = this.$toast({
                width: width,
                type: 'eject',
                title: true,
                t_url: 'multipleForms/index',
                extr: {
                    closeBtn: 'width: 80px; height: 80px;',
                    formList: forms,
                },
                viewPosition: 'components',
            });
            return YWShowMultipleForms;
        };

        // 流程在办
        Vue.prototype.$WFShowPhaseLayer = function (businessInstanceId, businessPhaseId) {
            const WFShowPhaseLayer = this.$toast({
                width: '90%',
                t_url: 'businessInstance/index',
                extr: {
                    code: {
                        businessInstanceUrl: 'simpleflow/processes/' + businessInstanceId + '/' + businessPhaseId,
                        businessInstanceId: businessInstanceId,
                        FormUseInJyFlow: true,
                    },
                },
                viewPosition: 'components',
            });
            return WFShowPhaseLayer;
        };

        // 流程场景
        Vue.prototype.$WFShowSceneLayer = function (businessInstanceId, sceneCode, tenant_id) {
            const WFShowSceneLayer = this.$toast({
                width: '90%',
                t_url: 'businessInstance/index',
                extr: {
                    code: {
                        businessInstanceUrl: `/simpleflow/scene/${businessInstanceId}/${sceneCode}`,
                        businessInstanceId: businessInstanceId,
                        FormUseInJyFlow: true,
                        tenant_id: tenant_id,
                    },
                },
                viewPosition: 'components',
            });
            return WFShowSceneLayer;
        };

        /* 插件名：流程启动时
        * configBusinessCode： 流程编码
        * term：自定义参数
        * _this：当前打开流程对象。仅用于刷新打开流程的列表.
        */
        Vue.prototype.$WFShowStartLayer = function (configBusinessCode, term, _this) {
            const WFShowStartLayer = this.$toast({
                width: '90%',
                t_url: 'businessInstance/index',
                extr: {
                    code: {
                        businessInstanceUrl: '/simpleflow/businessinstance/templateinfo/' + configBusinessCode,
                        configBusinessCode: configBusinessCode,
                        FormUseInJyFlow: true,
                        term: term,
                        procedure: true,
                        obj: _this,
                    },
                },
                viewPosition: 'components',
            });
            return WFShowStartLayer;
        };
        /**
         *
         * @param {*} url // 图片路径
         * @param {*} name // 图片名称
         */
        Vue.prototype.$imagesDownload = async function (downloadUrl, name) {
            await axios({
                method: 'get',
                url: downloadUrl,
                responseType: 'blob',
            }).then(blobData => {
                const blob = new Blob([blobData], { type: 'application/octet-stream' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            });
        };

        /**
         * 刷新所有已打开列表组件
         */
        Vue.prototype.$updateTable = function () {
            (store.state.currentOpenList || []).forEach(item => {
                if (item.tableObj) {
                    item.tableObj.updateTable();
                }
            });
        };
    },
};
